// @flow
import React from "react";
import { type ContextRouter, type Location } from "react-router";
import { withRouter, Route } from "react-router-dom";
import { renderRoutes } from "react-router-config";
import { compose } from "redux";
import { connect } from "react-redux";
import { ScrollToTop } from "@nested/ui";
import MetaTags from "./MetaTags";
import routes from "./routes";
import { locationChange } from "./locationDucks";

type Props = {
  handleLocationChange(location: Location): void,
  transitioningFrom?: Location,
  currentLocation?: Location,
} & ContextRouter<{}>;

export class App extends React.Component<Props> {
  componentDidUpdate(prevProps: Props) {
    const { location, handleLocationChange } = this.props;
    if (prevProps.location.pathname !== location.pathname) {
      handleLocationChange(location);
    }
  }

  render() {
    const { transitioningFrom, currentLocation, location } = this.props;
    const current = transitioningFrom || currentLocation || location;
    return (
      <ScrollToTop pathname={current.pathname}>
        <MetaTags />
        <Route
          data-test="route-wrapper"
          location={current}
          render={() => renderRoutes(routes)}
        />
      </ScrollToTop>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLocation: state.location.currentLocation,
  transitioningFrom: state.location.transitioningFrom,
});

const mapDispatchToProps = (dispatch: *) => ({
  handleLocationChange: (location) => dispatch(locationChange(location)),
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(App);
